import React from 'react';
import PropTypes from 'prop-types';

import Header from '../components/header/Header';
import Footer from '../components/footer/Footer';
import '../styles/index.scss';
import '../styles/colors.scss';

const Layout = ({ children }) => (
  <main className="main-wrapper">
    <Header />
    <div className="main-wrapper__content">
      {children}
    </div>
    <Footer />
  </main>
)

Layout.propTypes = {
  children: PropTypes.array,
}

export default Layout



// WEBPACK FOOTER //
// ./src/components/layout.js